import { Link } from './components/Link';
import { profileMenuItems } from './config';

export const LinksList = () => {
  return (
    <div className="w-full flex justify-start items-start flex-col gap-3">
      {profileMenuItems.map((item) => (
        <Link
          key={item.route}
          route={item.route}
          content={item.content}
          Icon={item.Icon}
          onClick={item?.onClick}
        />
      ))}
    </div>
  );
};
